import { MODALSEGUNDO_HIDE, MODALSEGUNDO_SHOW } from "../../ActionTypes";

export const showSegundoModal = (template, params,listBotones,posicion,bloquearDissmiss) => (dispatch) => {
  dispatch({
    type: MODALSEGUNDO_SHOW,
    payload: {
      template: template,
      params: params,
      listBotones:listBotones,
      posicion:posicion,
      bloquearDissmiss: bloquearDissmiss
    },
  });
};

export const hideSegundoModal = () => (dispatch) => {
  dispatch({
    type: MODALSEGUNDO_HIDE,
  });
};
